import { render } from "./MortgagePaymentView.vue?vue&type=template&id=89aa8f20&ts=true"
import script from "./MortgagePaymentView.vue?vue&type=script&lang=ts"
export * from "./MortgagePaymentView.vue?vue&type=script&lang=ts"

import "./MortgagePaymentView.vue?vue&type=style&index=0&id=89aa8f20&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__